import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface State { hasError: boolean; }
interface Props { children: React.ReactNode; onReset?: () => void; }

export class AvatarErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('[AvatarErrorBoundary]', error);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: 200,
          bgcolor: '#0a0a18',
          gap: 1,
        }}
      >
        <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 700, letterSpacing: '0.08em' }}>
          CONNECTION LOST
        </Typography>
        <Button
          size="small"
          onClick={this.handleReset}
          sx={{ fontSize: '0.6rem', color: '#1f93ff', borderColor: '#1f93ff', textTransform: 'none' }}
          variant="outlined"
        >
          Reconnect
        </Button>
      </Box>
    );
  }
}
